<script lang="ts">
</script>

<div
	class="inline-block bg-black rounded px-1.5 text-xs text-fx-cyan border border-fx-grey-600 font-normal"
>
	Beta
</div>
